module.exports = __webpack_public_path__ + "static/media/searchengin.67cb14fb.svg";